import { render, staticRenderFns } from "./ManageFrame.vue?vue&type=template&id=7a3a8685&scoped=true&"
import script from "./ManageFrame.vue?vue&type=script&lang=js&"
export * from "./ManageFrame.vue?vue&type=script&lang=js&"
import style0 from "./ManageFrame.vue?vue&type=style&index=0&id=7a3a8685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a8685",
  null
  
)

export default component.exports